module.exports = __webpack_public_path__ + "static/img/3en.1eff31a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/3en.png
// module id = bRP0
// module chunks = 0